export const GIFT_CARDS = 'GIFT_CARDS'
export const SERIAL_TICKETS = 'SERIAL_TICKETS'
